import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { useTravellersInfoFooter } from "../Footer.hook";
import { fields } from "../constants";

export const TravellersInfo = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: editData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditData,
  } = useTravellersInfoFooter();

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    refetchEditData();
  }, [query.get("id")]);

  const AwardsFormConfig: FormConfig = {
    initialValues: {
      field_travellers_info_en: decodeHTML(
        dataById ? dataById.payload.field_travellers_info_en : editData ? editData?.[0]?.field_travellers_info_en : ""
      ),
      field_travellers_info_ms: decodeHTML(
        dataById ? dataById.payload.field_travellers_info_ms : editData ? editData?.[0]?.field_travellers_info_ms : ""
      ),
      field_travellers_info_zh: decodeHTML(
        dataById ? dataById.payload.field_travellers_info_zh : editData ? editData?.[0]?.field_travellers_info_zh : ""
      ),

      field_baggage_guide_en: decodeHTML(
        dataById ? dataById.payload.field_baggage_guide_en : editData ? editData?.[0]?.field_baggage_guide_en : ""
      ),
      field_baggage_guide_ms: decodeHTML(
        dataById ? dataById.payload.field_baggage_guide_ms : editData ? editData?.[0]?.field_baggage_guide_ms : ""
      ),
      field_baggage_guide_zh: decodeHTML(
        dataById ? dataById.payload.field_baggage_guide_zh : editData ? editData?.[0]?.field_baggage_guide_zh : ""
      ),
      field_baggage_guide_url: decodeHTML(
        dataById ? dataById.payload.field_baggage_guide_url : editData ? editData?.[0]?.field_baggage_guide_url : ""
      ),

      field_lag_restrict_en: decodeHTML(
        dataById ? dataById.payload.field_lag_restrict_en : editData ? editData?.[0]?.field_lag_restrict_en : ""
      ),
      field_lag_restrict_ms: decodeHTML(
        dataById ? dataById.payload.field_lag_restrict_ms : editData ? editData?.[0]?.field_lag_restrict_ms : ""
      ),
      field_lag_restrict_zh: decodeHTML(
        dataById ? dataById.payload.field_lag_restrict_zh : editData ? editData?.[0]?.field_lag_restrict_zh : ""
      ),
      field_lags_restrict_url: decodeHTML(
        dataById ? dataById.payload.field_lags_restrict_url : editData ? editData?.[0]?.field_lags_restrict_url : ""
      ),

      field_duty_free_en: decodeHTML(
        dataById ? dataById.payload.field_duty_free_en : editData ? editData?.[0]?.field_duty_free_en : ""
      ),
      field_duty_free_ms: decodeHTML(
        dataById ? dataById.payload.field_duty_free_ms : editData ? editData?.[0]?.field_duty_free_ms : ""
      ),
      field_duty_free_zh: decodeHTML(
        dataById ? dataById.payload.field_duty_free_zh : editData ? editData?.[0]?.field_duty_free_zh : ""
      ),
      field_duty_free_url: decodeHTML(
        dataById ? dataById.payload.field_duty_free_url : editData ? editData?.[0]?.field_duty_free_url : ""
      ),
    },
    fields: fields.travellersInfo,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["image"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field?.[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else if (field?.[0]?.url) {
          data[key] = field[0].url;
        } else {
          delete data[key]; // fallback in case of invalid field
        }
      } catch (error) {
        console.error("Image processing failed for:", key, error);
      }
    }

    const payload = {
      action: action,
      method: method,
      module: "Footer",
      subModule: `travellersInfo`,
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editData?.[0]?.id || dataById?.payload?.id }),
        ...data,
        publish: true,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      console.log("payload", payload);
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <>
      <DynamicForm
        isLoading={isLoadingData || drilldownLoading}
        config={AwardsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${eramanHost}/api/travellers-info-details/${editData?.[0]?.id || dataById?.payload?.id}`,
            "UPDATE",
            "PATCH",
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </>
  );
};
